import { useNavigate } from "react-router-dom";
import { ArrowRight, Info, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { useSiteData } from "@/hooks/useSite";
import { buildInfoMessage, whatsappUrl } from "@/lib/site";

export default function ServiceCard({ service, index = 0, compact = false }) {
  const navigate = useNavigate();
  const { settings } = useSiteData();
  const isOnline = service.mode === "online";

  return (
    <Reveal delay={index * 0.08} className="h-full">
      <article
        data-testid={`service-card-${service.id}`}
        className="group h-full flex flex-col bg-white rounded-[28px] p-8 lg:p-10 shadow-[0_2px_6px_rgba(51,48,45,0.05)] transition-all duration-500 hover:-translate-y-1.5 hover:bg-peach/40 hover:shadow-soft"
      >
        <span className="text-[11px] uppercase tracking-widest2 text-taupe font-medium">
          {isOnline ? "Online" : "In studio"}
        </span>

        <h3 className="font-display text-3xl lg:text-4xl leading-tight mt-6" data-testid={`service-name-${service.id}`}>
          {service.name}
        </h3>
        {!compact && service.tagline && (
          <p className="text-charcoal/70 mt-3 leading-relaxed">{service.tagline}</p>
        )}

        {service.includes?.length > 0 && (
          <ul className="mt-6 space-y-2.5 text-[15px] text-charcoal/80 border-t border-taupe/20 pt-6">
            {service.includes.map((inc, i) => (
              <li key={i} className="flex gap-3">
                <span aria-hidden="true" className="text-taupe mt-px">—</span>
                {inc}
              </li>
            ))}
          </ul>
        )}

        {service.note && (
          <p className="mt-5 flex gap-2 text-sm leading-relaxed text-deeptaupe italic">
            <Info size={16} className="shrink-0 mt-0.5" strokeWidth={1.5} />
            {service.note}
          </p>
        )}

        <div className="mt-auto pt-8 space-y-3">
          <button
            onClick={() => navigate(`/prenota?servizio=${service.id}`)}
            data-testid={`service-cta-${service.id}`}
            className="w-full inline-flex items-center justify-between rounded-full border border-deeptaupe/40 text-deeptaupe text-sm uppercase tracking-widest2 font-medium px-7 py-4 transition-all duration-300 group-hover:bg-deeptaupe group-hover:text-ivory hover:!bg-charcoal hover:!border-charcoal"
          >
            Richiedi appuntamento <ArrowRight size={16} />
          </button>
          <a
            href={whatsappUrl(settings.contact.whatsapp, buildInfoMessage(service))}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`service-info-${service.id}`}
            className="w-full inline-flex items-center justify-center gap-2 rounded-full text-sm uppercase tracking-widest2 font-medium text-charcoal/60 px-7 py-3 border border-transparent transition-colors duration-300 hover:text-deeptaupe hover:border-taupe/40"
          >
            <MessageCircle size={15} /> Richiedi informazioni
          </a>
        </div>
      </article>
    </Reveal>
  );
}
